.content {
  flex: 1;
  overflow-y: scroll;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 1.6rem;
}

.separator {
  width: 100%;
  height: 1px;
  margin: 3.2rem 0 2.4rem;
  background-color: var(--color-stroke-default);
}
